export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Site"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID du magasin"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du magasin"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lien de paiement"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actif"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non actif"])}
}